import mitt from 'mitt';

export const snackEmitter = mitt();

export function pushSnack(
  label,
  type,
  timeout = 3000,
  action = undefined,
  actionLabel = undefined
) {
  snackEmitter.emit('newSnack', { label, type, timeout, action, actionLabel });
}

export default { snackEmitter, pushSnack };
